<ng-template #refresh>
    <app-component-loading size="inline"></app-component-loading>
</ng-template>

<div class="wrap">
  <span class="title">Список участников</span>
    <ul class="users-list">
        <li *ngFor="let user of users; let i = index"
            [attr.data-index]="i"
        >
            <app-contract-avatar  [avatarSize]="'36px'" [userGuid]="user.member.guid"> </app-contract-avatar>
            <div (click)="helper.openProfileByGuid(user.member.guid)" data-action="openProfile">
                <span [class.blocked_user]="user.member.project_setting.observation_type === 'blocked'"
                      [class.inactive_user]="!user.member.is_active"
                >
                    {{('TASKS.TEXT.TASK_ROLES.' + user.role) | translate}}: {{ helper.fullName(user.member) }}
            </span>
            </div>
        </li>
    </ul>
</div>



